// import { randomBytes, randomInt } from "crypto";
import L from "leaflet";
import wmsIconUrl from "./icons/marker-icon-2x.png";

// Simple AJAX helper (since we can't assume jQuery etc. are present)
function ajax(url, callback) {
  var context = this,
    request = new XMLHttpRequest();
  console.log("request", request);
  request.onreadystatechange = change;
  request.open("GET", url);
  request.send();

  function change() {
    if (request.readyState === 4) {
      if (request.status === 200) {
        callback.call(context, request.responseText);
      } else {
        callback.call(context, "error");
      }
    } else return;
  }
}

function getTypeName(type) {
  const typeNames = {
    "1 = Pista ciclabile in sede propria": "Pista ciclabile in sede propria",
    "2 = Pista ciclabile su corsia riservata ricavata dalla carreggiata stradale":
      "Pista ciclabile su corsia riservata ricavata dalla carreggiata stradale",
    "3 = Pista ciclabile su corsia riservata ricavata dal marciapiede":
      "Pista ciclabile su corsia riservata ricavata dal marciapiede",
    "4 = Percorso promiscuo pedonale e ciclabile":
      "Percorso promiscuo pedonale e ciclabile",
    "5 = Percorso promiscuo ciclabile e veicolare":
      "Percorso promiscuo ciclabile e veicolare",
    "6 = Percorso promiscuo all’interno di corsia preferenziale riservata al transito degli autobus":
      "Percorso promiscuo all’interno di corsia preferenziale riservata al transito degli autobus",
    "7 = Corsia emergenziale": "Corsia emergenziale",
    "8 = Percorso consigliato (indicazione Ufficio/Assessorato)":
      "Percorso consigliato (indicazione Ufficio/Assessorato)",
    "1 = Asfaltato": "Asfaltato",
    "2 = Sterrato": "Sterrato",
    "3 = Ciottolato": "Ciottolato",
    "4 = Pavimentato": "Pavimentato",
  };
  return typeNames[type];
}

function getTypeColor(type) {
  const types = {
    "1 = Pista ciclabile in sede propria": "bg-primary",
    "2 = Pista ciclabile su corsia riservata ricavata dalla carreggiata stradale":
      "bg-green-500",
    "3 = Pista ciclabile su corsia riservata ricavata dal marciapiede":
      "bg-red-300",
    "4 = Percorso promiscuo pedonale e ciclabile": "bg-indigo-600",
    "5 = Percorso promiscuo ciclabile e veicolare": "bg-gray-400",
    "6 = Percorso promiscuo all’interno di corsia preferenziale riservata al transito degli autobus":
      "bg-gray-600",
    "7 = Corsia emergenziale": "bg-red-600",
    "8 = Percorso consigliato (indicazione Ufficio/Assessorato)":
      "bg-yellow-300",
    "1 = Asfaltato": "bg-primary",
    "2 = Sterrato": "bg-green-500",
    "3 = Ciottolato": "bg-red-500",
    "4 = Pavimentato": "bg-indigo-600",
  };
  return types[type];
}

const wmsIcon = new L.Icon({
  iconAnchor: [16, 43],
  iconUrl: wmsIconUrl,
  iconSize: new L.Point(32, 43),
  popupAnchor: [0, -43],
});

const marker = L.marker([], {
  iconUrl: wmsIconUrl,
  iconSize: new L.Point(32, 43),
  popupAnchor: [0, -43],
});

// const info = L.control();


L.TileLayer.BetterWMS = L.TileLayer.WMS.extend({
  ajax: function (url, callback) {
    ajax.call(this, url, callback);
  },

  showWaiting: function () {
    // Hook to customize AJAX wait animation
    if (!this._map) return;
    this._map._container.style.cursor = "progress";
  },

  hideWaiting: function () {
    // Hook to remove AJAX wait animation
    if (!this._map) return;
    this._map._container.style.cursor = "pointer";
  },

  onAdd: function (map) {
    // Triggered when the layer is added to a map.
    //   Register a click listener, then do all the upstream WMS things
    L.TileLayer.WMS.prototype.onAdd.call(this, map);

    map.on("click", this.getFeatureInfo, this);
  },

  onRemove: function (map) {
    // Triggered when the layer is removed from a map.
    //   Unregister a click listener, then do all the upstream WMS things
    L.TileLayer.WMS.prototype.onRemove.call(this, map);
    map.off("click", this.getFeatureInfo, this);
  },

  getFeatureInfo: function (evt) {
    // Make an AJAX request to the server and hope for the best
    // return;
    // evt.preventDefault();

    var url = this.getFeatureInfoUrl(evt.latlng),
      showResults = L.Util.bind(this.showGetFeatureInfo, this);
    this.showWaiting();

    this.ajax(url, done);

    function done(data) {
      this.hideWaiting();
      var err = typeof data === "string" ? null : data;
      showResults(err, evt.latlng, data, this._map);
      //   showResults(result);
      //   var text = this.parseFeatureInfo(result, url);
      //   callback.call(this, latlng, text);
    }
  },

  getFeatureInfoUrl: function (latlng) {
    // Construct a GetFeatureInfo request URL given a point
    
  
    var point = this._map.latLngToContainerPoint(latlng, this._map.getZoom()),
      size = this._map.getSize(),
      params = {
        request: "GetFeatureInfo",
        service: "WMS",
        styles: this.wmsParams.styles,
        transparent: this.wmsParams.transparent,
        version: this.wmsParams.version,
        format: this.wmsParams.format,
        bbox: this._map.getBounds().toBBoxString(),
        height: size.y,
        width: size.x,
        layers: this.wmsParams.layers,
        query_layers: this.wmsParams.layers,
        info_format: "application/geojson",
      };
    if (params.version === "1.3.0") {
      params["crs"] = "EPSG:4326";
    }
    else {
      params['srs'] = "EPSG:4326";
        
    }

    params[params.version === "1.3.0" ? "i" : "x"] = point.x;
    params[params.version === "1.3.0" ? "j" : "y"] = point.y;

    return this._url + L.Util.getParamString(params, this._url, true);
  },

  showGetFeatureInfo: function (err, latlng, content, map) {
    if (err) {
      return;
    } // do nothing if there's an error
    const jsonContent = JSON.parse(content);
    const features = jsonContent.features;
    console.log(features);
    // this. (err, latlng, content, map)
    console.log(this._url, this);
    switch (this._url) {
      case "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/BGinBicicletta_ReteCiclabile/MapServer/WMSServer?":
        doSomethink(err, latlng, content, map);
        break;
      case "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/ZTL/MapServer/WMSServer?":
        // let features = response.features;
        if (features != null && features.length > 0) {
          let feature = features[0];

          let testo = "";

          if (feature.properties["NOME_ZTL"] !== undefined) {
            testo += "Nome ZTL: " + feature.properties["NOME_ZTL"];
          }
          if (feature.properties["DETTAGLI"] !== undefined) {
            testo +=
              testo !== ""
                ? ", " + feature.properties["DETTAGLI"]
                : feature.properties["DETTAGLI"];
          }

        
          if (feature.properties["PG_Ordinanza"] !== undefined) {
            testo +=
              testo !== ""
                ? ", ORDINANZA: " + feature.properties["PG_Ordinanza"]
                : " ORDINANZA: " + feature.properties["PG_Ordinanza"];
          }
          this.options.onShow(testo);
        } else {
          this.options.onShow(null);
        }
        break;
      case "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/Zone30_20_10/MapServer/WMSServer?":
        if (features != null && features.length > 0) {
          let feature = features[0];

          let testo = "";
          

          if(feature.properties['Tipologia'] !== undefined) 
          {
            testo +=
              testo !== ""
              ? ', ' + feature.properties['Tipologia'] 
              : feature.properties['Tipologia']; 
          }

          if(feature.properties['Descrizione'] !== undefined) 
          {
            testo +=
            testo !== ""
            ? ', ' + feature.properties['Descrizione'] 
            : feature.properties['Descrizione']; 
          }
        
          this.options.onShow(testo);
        } else {
          this.options.onShow(null);
        }
        break;
      case "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/Zone30_20_10_test_BGinBicicletta/MapServer/WmsServer?":
        if (features != null && features.length > 0) {
          let feature = features[0];

          let testo = "";
          if (feature.properties["Zona20"] !== undefined) {
            testo += feature.properties["Zona20"];
          }
          if (feature.properties["Zona30"] !== undefined) {
            testo += feature.properties["Zona30"];
          }
          if (feature.properties["TrafficoModeratoa30"] !== undefined) {
            testo +=
              testo !== ""
                ? ", " + feature.properties["TrafficoModeratoa30"]
                : feature.properties["TrafficoModeratoa30"];
          }
          if (feature.properties["TrafficoModeratoa20"] !== undefined) {
            testo +=
              testo !== ""
                ? ", " + feature.properties["TrafficoModeratoa20"]
                : feature.properties["TrafficoModeratoa20"];
          }
        
          this.options.onShow(testo);
        } else {
          this.options.onShow(null);
        }
        break;

      default:
        console.log("Default case");
    }

    // Otherwise show the content in a popup, or something.
  },
  addLegend: (latlng) => {
   
  },
});

L.tileLayer.betterWms = function (url, options) {
  console.log("OPTIONS", options);
  return new L.TileLayer.BetterWMS(url, options);
};

function doSomethink(err, latlng, content, map) {
  // const / map = content.map;
  const jsonContent = JSON.parse(content);
  const features = jsonContent.features;
  let contents = [];
  for (let feature in features) {
    const properties = features[feature].properties;

    switch (features[feature].layerName) {
      case "0":
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Percorso</h1>`
        );
        contents.push(`<div class="p-1 py-2">${properties.DESCRIZIONE}</br>`);
        contents.push(`Direzione: ${properties.DIREZIONE}</br>`);

        // contents.push(`${properties.DIREZIONE}`);
        // contents.push(`Lunghezza: ${properties.LUNGHEZZA} m`);
        contents.push(
          `<strong>Fondo stradale</strong><br/><div class="flex  space-x-2 flex-row"><div class="${getTypeColor(
            properties.FONDO
          )}  w-4 h-4"></div><div>${getTypeName(properties.FONDO)}</div></div>`
        );
        // contents.push(`Segnaletica: ${properties.SEGNALETICAciclabile}`);

        contents.push(
          `<strong>Tipo</strong><br/><div class="flex space-x-2 flex-row"><div class="${getTypeColor(
            properties.TIPO
          )} w-4 h-4"></div><div>${getTypeName(
            properties.TIPO
          )}</div></div></div></div>`
        );
        break;
      case "1":
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Percorso</h1>`
        );
        contents.push(`<div class="p-1 py-2">${properties.DESCRIZIONE}</br>`);
        contents.push(`Direzione: ${properties.DIREZIONE}</br>`);
        // contents.push(`Lunghezza: ${properties.LUNGHEZZA} m`);
        contents.push(
          `<strong>Fondo stradale</strong><br/><div class="flex  space-x-2 flex-row"><div class="${getTypeColor(
            properties.FONDO
          )}  w-4 h-4"></div><div>${getTypeName(properties.FONDO)}</div></div>`
        );
        // contents.push(`Segnaletica: ${properties.SEGNALETICAciclabile}`);

        contents.push(
          `<strong>Tipo</strong><br/><div class="flex space-x-2 flex-row"><div class="${getTypeColor(
            properties.TIPO
          )} w-4 h-4"></div><div>${getTypeName(
            properties.TIPO
          )}</div></div></div></div>`
        );
        break;

      case "2":
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Percorso</h1>`
        );
        contents.push(`<div class="p-1 py-2">${properties.DESCRIZIONE}</br>`);
        contents.push(`Direzione: ${properties.DIREZIONE}</br>`);
        // contents.push(`Lunghezza: ${properties.LUNGHEZZA} m`);
        contents.push(
          `<strong>Fondo stradale</strong><br/><div class="flex  space-x-2 flex-row"><div class="${getTypeColor(
            properties.FONDO
          )}  w-4 h-4"></div><div>${getTypeName(properties.FONDO)}</div></div>`
        );
        // contents.push(`Segnaletica: ${properties.SEGNALETICAciclabile}`);

        contents.push(
          `<strong>Tipo</strong><br/><div class="flex space-x-2 flex-row"><div class="${getTypeColor(
            properties.TIPO
          )} w-4 h-4"></div><div>${getTypeName(
            properties.TIPO
          )}</div></div></div></div>`
        );
        //   contents.push(`Tipo: ${properties.TIPO}`);
        break;
      case "3":
        // contents.push(
        //   `<strong>Direttrice ${properties.BiciPlan22_Direttrici}</strong>`
        // );
        // contents.push(
        //   `Direttrice: <strong>${properties.BiciPlan22_Direttrici}</strong>`
        // );
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Percorso</h1><div class="p-1 py-2">${properties.DESCRIZIONE}</br>`
        );
        // contents.push(`Lunghezza: ${properties.LUNGHEZZA} m`);
        contents.push(`Direzione: ${properties.DIREZIONE}</br>`);
        contents.push(
          `<strong>Fondo stradale</strong><br/><div class="flex  space-x-2 flex-row"><div class="${getTypeColor(
            properties.FONDO
          )}  w-4 h-4"></div><div>${getTypeName(properties.FONDO)}</div></div>`
        );
        // contents.push(`Segnaletica: ${properties.SEGNALETICAciclabile}`);

        contents.push(
          `<strong>Tipo</strong><br/><div class="flex space-x-2 flex-row"><div class="${getTypeColor(
            properties.TIPO
          )} w-4 h-4"></div><div>${getTypeName(
            properties.TIPO
          )}</div></div></div></div>`
        );
        break;
      // case "4":
      //   contents.push("<strong>Interconnessioni esistenti</strong>");
      //   contents.push(
      //     `Direttrice: <strong>${properties.BiciPlan22_Direttrici}</strong>`
      //   );
      //   contents.push(`Lunghezza: ${properties.LUNGHEZZA} m`);

      //   break;
      case "5":
        // contents.push(<strong>Direttrice</strong>");
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Direttrice ${properties.BiciPlan22_Direttrici}</h1>`
        );
        contents.push(
          `<div class="p-1 py-2">Lunghezza: ${properties.LUNGHEZZA} m</div>`
        );

        contents.push(
          // `<div id="tracciato" class="flex flex-row justify-start items-center"><strong class="p-1 py-2">TIPOLOGIA TRACCIATO</strong><div class="btn content-center text-center bg-secondary font-semibold rounded-full w-4 h-4 mr-2 text-white">?</div></div>`
          ` <div class="items-center  duration-300 transition-all  FAQ">
              <a href="#show1" class="show my-2 rounded-full text-base font-bold mb-2 text-secondary" id="show1">?</a>
              <a href="#hide1" class="hide my-2 rounded-full mb-2 text-secondary text-base" id="hide1">X</a>
              <div class="question pt-1 ml-1 my-2 font-bold text-xs">TIPOLOGIA TRACCIATO</div>
              <div class="list flex-1 flex flex-col mb-2 pb-2 duration-300 transition-all">
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-primary h-4"></div><div class=" w-48">Pista ciclabile in sede propria</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-green-500 h-4"></div><div class=" w-48">Pista ciclabile su corsia riservata ricavata dalla carreggiata stradale</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-red-300 h-4"></div><div class=" w-48">Pista ciclabile su corsia riservata ricavata dal marciapiede</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-indigo-600 h-4"></div><div class=" w-48">Percorso promiscuo pedonale e ciclabile</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-gray-400 h-4"></div><div class=" w-48">Percorso promiscuo ciclabile e veicolare</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-gray-600 h-4"></div><div class=" w-48">Percorso promiscuo all’interno di corsia preferenziale riservata al transito degli autobus</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-red-600 h-4"></div><div class=" w-48">Corsia emergenziale</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-yellow-300 h-4"></div><div class=" w-48">Percorso consigliato (indicazione Ufficio/Assessorato)</div></div>
              </div>
          </div>`
        );


        const tipi = properties.TIPO_x100.split(",").map((v) => parseInt(v));

        let tot = tipi.reduce((sum, val) => sum + val, 0);
        let tipo = '<div class="h-6 w-full flex px-1 mb-2 flex-row space-x-0">';
        let colori = ["bg-primary","bg-green-500", "bg-red-300", "bg-indigo-600", "bg-gray-400", "bg-gray-600", "bg-red-600", "bg-yellow-300" ];

        tipi.forEach((value, index) => {
          // Calcola la percentuale correttamente
          const width = (value / tot) * 100;
          
          // Usa lo stile inline con sintassi HTML corretta
          tipo += `<div style="width: ${width}%" class="${colori[index]} h-full"></div>`;
        });
        tipo += "</div>"
       




        contents.push(tipo);

        contents.push(
          `
            <div class="items-center  duration-300 transition-all  FAQ2">
              <a href="#show2" class="shows my-2 rounded-full text-base font-bold mb-2 text-secondary" id="show2">?</a>
              <a href="#hide2" class="hides my-2 b-2 rounded-full text-secondary text-base" id="hide2">X</a>
              <div class="question2   pt-1 ml-1 my-2 font-bold text-xs">TIPOLOGIA FONDO STRADALE</div>
              <div class="list2 flex-1 flex flex-col mb-2 pb-2 space-y-1 duration-300 transition-all">
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1  bg-primary h-4"></div><div class=" w-48">Asfaltato</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1 bg-green-500 h-4"></div><div class=" w-48">Sterrato</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1  bg-red-500 h-4"></div><div class=" w-48">Ciottolato</div></div>
                  <div class="mx-2 flex flex-row items-center space-x-2"><div class="w-4 p-1  bg-indigo-500 h-4"></div><div class=" w-48">Pavimentato</div></div>
              </div>
            </div>
             `
        );

        const fondi = properties.FONDO_x100.split(",").map((v) => parseInt(v));

        // const values = [94, 0, 0, 6];
        const colors = ["bg-primary", "bg-green-500", "bg-red-500", "bg-indigo-600"];

        let total = fondi.reduce((sum, val) => sum + val, 0);
        let fondo = '<div class="h-6 w-full flex px-1 mb-2 flex-row">';

        fondi.forEach((value, index) => {
          // Calcola la percentuale correttamente
          const width = (value / total) * 100;
          
          // Usa lo stile inline con sintassi HTML corretta
          fondo += `<div style="width: ${width}%" class="${colors[index]} h-full"></div>`;
        });

        fondo += '</div>';

        console.log(fondi);

       
        contents.push(fondo);

        break;
      case "6":
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Connessione Comuni limitrofi</h1>`
        );

        contents.push(
          `<div class="p-1 py-2 font-semibold">${properties.DirezioneComunelimitrofo}</div>`
        );

        break;
      case "7":
        contents.push(
          `<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Quartiere</h1>`
        );
        contents.push(
          `<div class="p-1 py-2 font-semibold">${properties.NOME}</div></div>`
        );

        break;

      default:
        break;
    }
  }
  if (contents.length > 0) {
    marker.removeFrom(map);
    const popup = L.popup({ maxWidth: 800 })
      .setLatLng(latlng)

      .setContent("<br>" + contents.join(""));
    marker.setIcon(wmsIcon);

    marker.setLatLng(latlng).addTo(map);

    marker.bindPopup(popup).openPopup();


  }
}

export default L.tileLayer.betterWms;
